import authToken, { userAuthorization } from './token';
import { onTokenChange } from './event';

export { onTokenChange, userAuthorization };
export default authToken;
